/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Career } from '../../models/career';

export interface ApiMasterCareerGetAllGet$Params {
}

export function apiMasterCareerGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterCareerGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Career>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterCareerGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Career>>;
    })
  );
}

apiMasterCareerGetAllGet.PATH = '/api/Master/Career/GetAll';
